import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import AllergyActionPlanFormComp from '../../../../components/registrationPacket/AllergyActionPlanFormComp';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchAllergyActionPlans, submitAllergyActionPlan } from '../../../../store/allergyActionPlan/allergyActionPlanSlice';
import { getEffectiveStudentId } from '../../../../utilities/teacherModulePermissions';
import Swal from 'sweetalert2';

const AllergyActionPlanForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const planData = useSelector(state => id ? state.allergyActionPlan.plans.find(plan => plan.id === parseInt(id)) : null);
  let profileData = useSelector((state) => state.setting.setting.user_data);
  profileData = profileData ? JSON.parse(profileData) : null;

  // planData above only resolves if state.allergyActionPlan.plans is
  // already populated - true if the parent came here via the list page
  // (which fetches it), but not on a direct navigation to this edit URL
  // (a fresh load, a page refresh, or a link from somewhere else) - in
  // which case the form previously rendered blank instead of the saved
  // plan. Dispatching the same fetch here too closes that gap regardless
  // of how this screen was reached; once it resolves, planData updates and
  // AllergyActionPlanFormComp's own defaultData effect picks up the change.
  useEffect(() => {
    if (!isEditMode) return;
    dispatch(fetchAllergyActionPlans({ page: 1, limit: 20, student_id: getEffectiveStudentId(profileData) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, id]);

  const handleSubmit = async (formData) => {
    try {
      await dispatch(submitAllergyActionPlan({ ...formData, student_id: getEffectiveStudentId(profileData) })).unwrap();
      await Swal.fire({
        title: 'Success!',
        text: `Allergy Action Plan ${isEditMode ? 'updated' : 'created'} successfully.`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
      navigate('/dashboard/allergy-action-plan/list');
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error || 'Failed to submit allergy action plan.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  const handleCancel = () => {
    navigate('/dashboard/allergy-action-plan/list');
  };

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title d-flex align-items-center">
                <i className="icon material-symbols-outlined me-2" style={{ verticalAlign: 'middle', fontSize: '22px' }}>health_and_safety</i>
                <h4 className="card-title mb-0">
                  {isEditMode ? 'Edit' : 'Create'} Allergy/Anaphylaxis Action Plan
                </h4>
              </div>
              <Button variant="outline-secondary" onClick={() => navigate('/dashboard/allergy-action-plan/list')}>
                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>arrow_back</i>
                Back to List
              </Button>
            </Card.Header>
            <Card.Body>
              <AllergyActionPlanFormComp 
                isEditMode={isEditMode} 
                defaultData={planData || {}} 
                onSubmit={handleSubmit}
                onCancel={handleCancel}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AllergyActionPlanForm;
